@if (team) {
  <button mat-raised-button color="accent" (click)="inviteMember()">
    <mat-icon>add</mat-icon>
    <span i18n>Zum Team einladen</span>
  </button>
  <div class="table-wrapper mat-elevation-z3">
    <mat-form-field subscriptSizing="dynamic">
      <mat-label i18n>Filter</mat-label>
      <input matInput [(ngModel)]="dataSource.filter" />
    </mat-form-field>
    <mat-table [dataSource]="dataSource" matSort>
      <!-- User name Definition -->
      <ng-container matColumnDef="name">
        <mat-header-cell *matHeaderCellDef i18n mat-sort-header="displayName">Name</mat-header-cell>
        <mat-cell *matCellDef="let row">
          @if (row.isInvitee) {
            @if (row.invite.status === 'rejected') {
              <mat-icon class="error-icon">error</mat-icon>
              <ng-container i18n>Einladung abgelehnt</ng-container>
            } @else {
              <ng-container i18n>Ausstehende Einladung</ng-container>
            }
          } @else {
            <dt-team-member-name [showEmailWhenNoName]="false" [member]="row"></dt-team-member-name>
          }
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="email">
        <mat-header-cell *matHeaderCellDef i18n mat-sort-header="user.email">E-Mail-Adresse</mat-header-cell>
        <mat-cell #emailRow *matCellDef="let row">
          @if (row.isInvitee) {
            @if (currentlyEditingEmailOf !== row) {
              <span>{{ row.invite.email }}</span>
              <button
                mat-icon-button
                i18n-matTooltip
                matTooltip="E-Mail-Adresse ändern"
                color="accent"
                class="edit-email-button"
                (click)="this.currentlyEditingEmailOf = row"
              >
                <mat-icon>edit</mat-icon>
              </button>
            } @else {
              <div class="edit-email-container">
                <input
                  #emailInput
                  matInput
                  dtAutoFocus
                  type="email"
                  [dtAutoFocusSelectAll]="true"
                  [value]="row.invite.email"
                  (click)="$event.stopPropagation()"
                  (blur)="currentlyEditingEmailOf = null"
                  (keyup.enter)="updateEmail(emailRow, emailInput.value)"
                  (keydown.escape)="currentlyEditingEmailOf = null; $event.stopPropagation()"
                />
                <div class="buttons">
                  <button
                    mat-icon-button
                    color="accent"
                    (mousedown)="$event.preventDefault()"
                    (click)="updateEmail(emailRow, emailInput.value)"
                    i18n-matTooltip
                    matTooltip="Speichern und Einladung erneut senden"
                  >
                    <mat-icon>save</mat-icon>
                  </button>

                  <button mat-icon-button color="accent" (click)="currentlyEditingEmailOf = null" i18n-matTooltip matTooltip="Abbrechen">
                    <mat-icon>close</mat-icon>
                  </button>
                </div>
              </div>
            }
          } @else {
            @if (row.user) {
              <span>{{ row.user.email }}</span>
            } @else {
              <span i18n class="italic">Virtuelles Teammitglied</span>
            }
          }
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="createdAt">
        <mat-header-cell *matHeaderCellDef i18n mat-sort-header="createdAt">Mitglied seit</mat-header-cell>
        <mat-cell *matCellDef="let row">
          @if (row.createdAt) {
            <span>{{ row.createdAt | date: 'short' }}</span>
          } @else {
            <ng-container i18n>—</ng-container>
          }
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="role">
        <mat-header-cell *matHeaderCellDef i18n mat-sort-header="role">Rolle</mat-header-cell>
        <mat-cell *matCellDef="let row">
          @if (row.user != null || row.isInvitee) {
            <mat-select
              #select
              [ngModel]="row.role"
              (selectionChange)="updateRole(row, $event.value, select)"
              [disabled]="row.id === userMemberId"
            >
              @for (role of availableTeamRoles; track role) {
                <mat-option [value]="role" [disabled]="!canUserChangeRoleTo(row, role)">
                  <span i18n>{{ role | teamMemberRole }}</span>
                </mat-option>
              }
            </mat-select>
          }
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="actions">
        <mat-header-cell *matHeaderCellDef i18n></mat-header-cell>
        <mat-cell *matCellDef="let row; index as index" class="action-cell">
          @if (row.user) {
            <button
              mat-icon-button
              color="accent"
              (click)="turnMemberVirtual(row)"
              [disabled]="realMemberCount === 1 || row.role === 'owner'"
              [hidden]="row.id === userMemberId"
              i18n-matTooltip
              matTooltip="In Virtuelles Teammitglied umwandeln"
            >
              <mat-icon>logout</mat-icon>
            </button>
          }
          @if (row.isInvitee) {
            <button
              #resend
              mat-icon-button
              color="accent"
              (click)="resendInvite(resend, row)"
              i18n-matTooltip
              matTooltip="Einladung erneut senden"
            >
              <mat-icon>send</mat-icon>
            </button>
          }
          <button
            mat-icon-button
            color="accent"
            (click)="deleteMember(row)"
            [disabled]="row.role === 'owner'"
            [hidden]="row.id === userMemberId"
            [matTooltip]="getDeleteTooltip(row)"
          >
            <mat-icon>delete</mat-icon>
          </button>
        </mat-cell>
      </ng-container>
      <!-- Header and Row Declarations -->
      <mat-header-row *matHeaderRowDef="['name', 'email', 'createdAt', 'role', 'actions']"></mat-header-row>
      <mat-row *matRowDef="let row; columns: ['name', 'email', 'createdAt', 'role', 'actions']" [class.invite]="row.isInvitee"></mat-row>
    </mat-table>
  </div>
}

@if (!team) {
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
}
